import React from 'react'
import { PlaceOrderSameDayPage } from './order.same.day.kits.page';
const PlaceOrderSameDayPageV2 = (props) => {
    return (
        <div>
            <PlaceOrderSameDayPage {...props} />
        </div>
    )
}
export default PlaceOrderSameDayPageV2